import projectsPagePt from "./ProjectsPage/projectsPagePt";

const textPt = {
  pt: {
    menu: {
      home: "Home",
      projects: "Projetos",
      about: "Sobre",
    },
    introduction: {
      introPt1: "A comunicação que fazemos hoje é o impacto que colhemos amanhã!",
      introPt2: "Queremos caminhar lado a lado de quem transforma realidades, criando narrativas que informam, mobilizam e inspiram novas formas de existir. Porque a comunicação é uma ferramenta poderosa para criar novas visões de mundo e construir o futuro que queremos!",
      button: "Saiba +",
    },
    instaFeed: {
      title: "NOVIDADES"
    },
    footer: {
      info: "Site por Utópika Estúdio Criativo"
    },
    aboutPage: {
      intro: {
        title: 'Utopiar é transformar o futuro',
        paragraph1: `Aqui na Utópika, acreditamos que a comunicação é uma ferramenta de transformação e parte da solução dos problemas que enfrentamos no mundo!`,
        paragraph2: `Nosso compromisso é contar histórias que importam, amplificar vozes que precisam ser ouvidas e criar campanhas que provoquem mudanças reais. Atuamos na interseção entre criatividade e impacto, construindo imagens que carregam propósito.`,
        paragraph3: `Caminhamos lado a lado com a organizações, movimentos sociais, e marcas, que estão reimaginando o presente para transformar o futuro. Queremos estar perto e unidos na construção de narrativas que tragam solução, imaginação e propósito.`,
        paragraph4: `De exposições imersivas a campanhas gráficas, da identidade visual à animação, nossa equipe se mobiliza para dar forma a ideias que movem o mundo.`,
        paragraph5: `O design pode – e deve – estar do lado certo da história. Vamos fazer acontecer?`,
      },
      profile: {
        julia: {
          name: 'Julia Lima',
          role: 'Sócia e diretora criativa',
          text: `Designer, ilustradora e motion designer. Com mais de uma década de atuação, trabalha na interseção entre design, narrativa 
          e impacto social. Entende o design como prática coletiva e comprometida com a realidade, capaz de ampliar vozes e 
          construir conexões significativas. Atua com expografia e design de jogos, traduzindo temas complexos em experiências 
          acessíveis. Na Utópika, lidera equipes e projetos que combinam clareza, imaginação e transformação. Acredita que o 
          design só faz sentido quando tem coragem de interferir no mundo.`,
          hasImage: true
        },
        rachel: {
          name: 'Rachel Gepp',
          role: 'Sócia e diretora criativa',
          text: `Publicitária, designer e ilustradora. Une inteligência criativa a repertório prático para desenvolver projetos com 
          vocação crítica e impacto social. Na Utópika, cria identidades visuais e conteúdos gráficos para organizações sociais, 
          culturais e ambientais, traduzindo pautas complexas para públicos diversos. Usa o design como ferramenta de provocação, 
          mobilização e mudança. Acredita que comunicar com honestidade é um ato político.`,
          hasImage: true
        },
        ana: {
          name: 'Ana Clara',
          role: 'Designer',
          text: `Participou de projetos de extensão e pesquisa, consolidando uma visão transdisciplinar e crítica do design. Mesmo diante 
          de retrocessos e discursos conservadores, mantém um olhar propositivo e acredita na comunicação como potência de transformação. 
          Na Utópika, contribui para projetos que refletem diversidade, escuta e compromisso com o futuro. Acredita que o design coletivo 
          e plural é uma força de mobilização.`,
          hasImage: false
        },
        mauricio: {
          name: 'Maurício Boff',
          role: 'Parceiro estratégico da Utópika',
          text: `Consultor em comunicação e facilitação socioambiental, escritor e parceiro estratégico da Utópika. Atua há mais de 
          15 anos com estratégias de impacto em projetos de conservação, regeneração e justiça climática na América do Sul. Movido 
          pela escuta e pelo diálogo intercultural, trabalha para transformar discursos em mudança concreta. Acredita que comunicar 
          é conectar mundos e semear possibilidades de futuro.`,
          hasImage: false
        },
      },
      socialMedia: {
        julia: {
          instagram: "https://www.instagram.com/jotalimac/",
          linkedin: "https://www.linkedin.com/in/julia-lima/",
        },
        rachel: {
          instagram: "https://www.instagram.com/gepprachel/",
          linkedin: "https://www.linkedin.com/in/rachelgepp/",
        },
      },
      clients: {
        title: "Clientes",
      }
    },
    projectsPage: projectsPagePt,
  }
};

export default textPt;
